import { GlSprintf } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'SearchResultFocusLayover',
    components: {
        GlSprintf
    },
    props: {
        textMessage: {
            type: String,
            required: true
        }
    }
};
